(() => {
  const body = document.body;
  const launcher = document.querySelector('.rosarium-whatsapp-launcher');
  if (!body || !launcher) return;

  const productRowSelector = [
    'main .product-list-section .resource-list',
    'main .product-grid-container',
    'main .product-grid',
    'main product-recommendations',
    'main [data-testid="resource-list-grid"]',
  ].join(', ');

  const minimumExpandedDuration = 3000;
  const idleCollapseDuration = 5000;
  const scrollCollapseDistance = 135;

  let visible = false;
  let autoCollapseComplete = false;
  let revealStartedAt = 0;
  let revealScrollY = 0;
  let scrollThresholdReached = false;
  let productObserver;
  let fallbackScrollHandler;
  let collapseScrollHandler;
  let minimumExpandedTimer;
  let idleCollapseTimer;

  const setCollapsed = (shouldCollapse) => {
    body.classList.toggle('rosarium-whatsapp-collapsed', shouldCollapse);
  };

  const isInteracting = () => launcher.matches(':hover') || launcher.contains(document.activeElement);

  const clearAutoCollapseListeners = () => {
    if (collapseScrollHandler) {
      window.removeEventListener('scroll', collapseScrollHandler);
      collapseScrollHandler = undefined;
    }

    window.clearTimeout(minimumExpandedTimer);
    window.clearTimeout(idleCollapseTimer);
  };

  const completeAutoCollapse = () => {
    if (autoCollapseComplete) return;

    autoCollapseComplete = true;
    clearAutoCollapseListeners();

    if (!isInteracting()) {
      setCollapsed(true);
    }
  };

  const armAutoCollapse = () => {
    if (collapseScrollHandler || autoCollapseComplete) return;

    revealStartedAt = performance.now();
    revealScrollY = window.scrollY;

    minimumExpandedTimer = window.setTimeout(() => {
      if (scrollThresholdReached) {
        completeAutoCollapse();
      }
    }, minimumExpandedDuration);

    idleCollapseTimer = window.setTimeout(completeAutoCollapse, idleCollapseDuration);

    collapseScrollHandler = () => {
      const scrollDistance = Math.abs(window.scrollY - revealScrollY);
      if (scrollDistance < scrollCollapseDistance) return;

      scrollThresholdReached = true;

      if (performance.now() - revealStartedAt >= minimumExpandedDuration) {
        completeAutoCollapse();
      }
    };

    window.addEventListener('scroll', collapseScrollHandler, { passive: true });
  };

  const expandForInteraction = () => {
    if (!visible) return;
    setCollapsed(false);
  };

  const restoreCollapsedState = () => {
    window.setTimeout(() => {
      if (autoCollapseComplete && !isInteracting()) {
        setCollapsed(true);
      }
    }, 0);
  };

  launcher.addEventListener('pointerenter', expandForInteraction);
  launcher.addEventListener('pointerleave', restoreCollapsedState);
  launcher.addEventListener('pointerdown', expandForInteraction, { passive: true });
  launcher.addEventListener('focusin', expandForInteraction);
  launcher.addEventListener('focusout', restoreCollapsedState);

  const reveal = () => {
    if (visible) return;

    visible = true;
    body.classList.remove('rosarium-whatsapp-pending');
    body.classList.add('rosarium-whatsapp-visible');
    setCollapsed(false);
    armAutoCollapse();
    productObserver?.disconnect();

    if (fallbackScrollHandler) {
      window.removeEventListener('scroll', fallbackScrollHandler);
      fallbackScrollHandler = undefined;
    }
  };

  const firstProductRow = () => document.querySelector(productRowSelector);

  const watchProductRow = () => {
    const target = firstProductRow();
    if (!target) return false;

    if (!('IntersectionObserver' in window)) {
      reveal();
      return true;
    }

    productObserver?.disconnect();
    productObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          reveal();
        }
      },
      {
        root: null,
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.04,
      }
    );

    productObserver.observe(target);
    return true;
  };

  const installFallback = () => {
    if (fallbackScrollHandler) return;

    fallbackScrollHandler = () => {
      if (window.scrollY > window.innerHeight * 0.4) {
        reveal();
      }
    };

    window.addEventListener('scroll', fallbackScrollHandler, { passive: true });
  };

  const start = () => {
    if (watchProductRow()) return;

    window.setTimeout(() => {
      if (!watchProductRow()) {
        installFallback();
      }
    }, 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
